import axios from "axios";

const TokenStr = "123456789"; // process.env.tokenStr;
const Baseurl = process.env.REACT_APP_base_url;

var RestService = {
  getArticlesData(callback) {
    axios
      .request({
        url: `${Baseurl}page/articlesData`,
        method: "GET",
        ders: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `Basic ${TokenStr}`,
        },
      })
      .then(function (response) {
        callback(JSON.stringify(response));
      })
      .catch(function (error) {
        callback(JSON.stringify(error?.response));
        //return Promise.reject(error);
      });
  },
  getArticlesDetail(callback, mobile, web_token, article_slug) {
    axios
      .request({
        url: `${Baseurl}page/articlesDetail?mobile=${mobile}&web_token=${web_token}&article_id=${article_slug}`,
        method: "GET",
        ders: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `Basic ${TokenStr}`,
        },
      })
      .then(function (response) {
        callback(JSON.stringify(response));
      })
      .catch(function (error) {
        callback(JSON.stringify(error?.response));
        //return Promise.reject(error);
      });
  },
};

export default RestService;
